import React, { useContext, useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import LeadDetails from "components/sales/formSection/leadDetails/leadDetails";
import PocDetails from "components/sales/formSection/pocDetails/pocDetails";
import Location from "components/sales/formSection/location/location";
import Layout from "components/sales/layout/layout";
import { Button } from "react-bootstrap";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import OtherDetails from "components/sales/formSection/otherDetails/otherDetails";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import Notfound from "pages/notfound";

const EditB2bAlliances = ({
  locationCity,
  cities,
  locationZone,
  zones,
  locationArea,
  areas,
  locationType,
  locTypesData,
  locationState,
  state,
  locationPinCode,
  pincodeData,
  editAllianceLeadSubmit,
  getB2bDropDown,
  b2bDropDown,
  getCurrentLocation,
  latlng,
  toastMsg,
  match,
  viewDetails,
  getDetails,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [corporateLeadData, setCorporateLeadData] = useState(null);
  const [corporatePocDetails, setCorporatePocDetails] = useState(null);
  const [corporateLocation, setCorporateLocation] = useState(null);
  const [corporateCategoryDetails, setCorporateCategoryDetails] = useState(
    null
  );
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRender, setIsRender] = useState(false);

  useEffect(() => {
    if (match?.params?.id !== undefined && match?.params?.id !== null) {
      (async () => {
        const leadTypeId =
          (await JSON.parse(localStorage.getItem("viewDetail"))) &&
          JSON.parse(localStorage.getItem("viewDetail"))[0].lead_type_id;
        const requestData = {
          lead_id: match.params.id,
          lead_type: leadTypeId,
        };
        if (requestData) {
          const res = await getDetails(requestData);
          if (res === null || res === "") {
            setIsRender(true);
          }
        }
      })();
    }
  }, [getDetails]);

  const handleLeadSubmit = (val) => {
    setCorporateLeadData(val);
  };
  const handlePocSubmit = (val) => {
    setCorporatePocDetails(val);
  };
  const handleLocSubmit = (val) => {
    setCorporateLocation(val);
  };
  const handleCatSubmit = (val) => {
    setCorporateCategoryDetails(val);
  };
  const handleModalHide = () => setIsModal(false);

  const handleSubmit = (leadId) => {
    const editCorporate = {
      ...corporateLeadData,
      ...corporatePocDetails,
      ...corporateLocation,
      ...corporateCategoryDetails,
    };
    if (
      corporateLeadData === null ||
      corporatePocDetails === null ||
      corporateLocation === null ||
      corporateCategoryDetails === null
    ) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      (async () => {
        const res = await editAllianceLeadSubmit({
          ...editCorporate,
          leadId: leadId,
        });
        if (res) {
          setIsModal(true);
        }
      })();
    }
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getB2bDropDown();
      setTimeout(() => setIsLoading(false), 500);
    })();
  }, [getB2bDropDown]);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={() => handleSubmit(match?.params?.id)}
          className="btn btn-primary"
        >
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };
  return isRender ? (
    <Notfound />
  ) : (
    <Layout
      title={localization.createB2BAlliances}
      Buttons={headerBtns}
      className={isFiled ? "requiredFileds" : ""}
      isLoading={isLoading}
      isGoback
    >
      <LeadDetails
        inputLabel={localization.partnerCompanyName}
        isB2bAlliances={true}
        isCorporate={true}
        handleValue={handleLeadSubmit}
        b2bDropDown={b2bDropDown}
        prefilledData={viewDetails}
      />
      <PocDetails
        handleValue={handlePocSubmit}
        isb2b={true}
        b2bDropDown={b2bDropDown}
        prefilledData={viewDetails}
      />
      <Location
        locationCity={locationCity}
        cities={cities}
        locationZone={locationZone}
        zones={zones}
        locationArea={locationArea}
        areas={areas}
        locationType={locationType}
        locTypesData={locTypesData}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        handleValue={handleLocSubmit}
        locationState={locationState}
        state={state}
        isb2b={true}
        getCurrentLocation={getCurrentLocation}
        latlng={latlng}
        toastMsg={toastMsg}
        prefilledData={viewDetails}
      />
      <OtherDetails
        handleValue={handleCatSubmit}
        isB2b={true}
        b2bDropDown={b2bDropDown}
        prefilledData={viewDetails}
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <Link
            to={`${baseUrl}/preSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.preSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
          <Link
            to={`${baseUrl}/preSalesListing`}
            className="btn btn-transparent"
          >
            {localization.createAnother}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

EditB2bAlliances.propTypes = {
  locationCity: PropTypes.func,
  cities: PropTypes.any,
  locationZone: PropTypes.func,
  zones: PropTypes.any,
  locationArea: PropTypes.any,
  areas: PropTypes.any,
  locationType: PropTypes.func,
  locTypesData: PropTypes.any,
  locationState: PropTypes.func,
  state: PropTypes.any,
  locationPinCode: PropTypes.func,
  pincodeData: PropTypes.any,
  getCurrentLocation: PropTypes.func,
  toastMsg: PropTypes.any,
};

export default EditB2bAlliances;
